<!-- territory-dashboard.component.html - Reused from non-territory-dashboard -->

<app-layout>
  <div class="orders-container">
      
  



      <!-- ========== DASHBOARD / ORDERS DISPLAY ========== -->

      <div class="orders-grid-container">
        
        <!-- Customer Information Card -->

        
<mat-card class="customer-info-card">

  <span class="back-section" (click)="goBack()">
    <img src="assets/newimages/GoBack.png" alt="backward" />
    <a class="back-link"> Back to customer</a>
  </span>

  <mat-card-content>

    <div class="customer-details">

      <p>
        <span class="customer-name">
          <b>{{ this.customerInfo?.shipToName }}</b><br>
        </span>
        
<span class="customer-address">
<span *ngIf="this.customerInfo?.shipToAddress?.houseNumber"> {{ this.customerInfo?.shipToAddress?.houseNumber }},</span>
  {{ this.customerInfo?.shipToAddress?.street }},
  {{ this.customerInfo?.shipToAddress?.city }},
  {{ this.customerInfo?.shipToAddress?.state }},
  {{ this.customerInfo?.shipToAddress?.postalCode }},
  {{ this.customerInfo?.shipToAddress?.country }}
</span>

      </p>

      <div class="customer-numbers">
        <div class="ship-to">
          <span class="label">Ship to:</span>
          <span class="value">{{ this.customerInfo?.shipToNumber }}</span>
        </div>
        <div class="sold-to">
          <span class="label">Sold to:</span>
          <span class="value">{{ this.customerInfo?.soldToNumber }}</span>
        </div>
      </div>
    </div>

    <!-- ✅ SEARCH -->
    <form [formGroup]="filterForm" class="search-wrapper">

      <label class="search-label">
        Search all orders for this customer
      </label>

      <div class="search-box">
        <img src="assets/newimages/SearchIcon.png" class="search-icon" alt="Search" />

        <input
          type="text"
          formControlName="searchTerm" class="placeholder-text"
          placeholder="Order number, Delivery number, Customer PO number or Product number"
          class="search-input"
        />
      </div>

    </form>

  </mat-card-content>

</mat-card>

<div class="refresh-panel" *ngIf="showRefreshPanel" [class.refreshing]="isRefreshingCache">
        <div class="refresh-panel-header">
          <mat-icon class="refresh-panel-icon">notifications_active</mat-icon>
          <span class="refresh-panel-title">Latest Order Detail available</span>
          <button class="refresh-panel-close"
                  (click)="dismissRefreshPanel()"
                  [disabled]="isRefreshingCache"
                  aria-label="Dismiss">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="refresh-panel-body">
          <p>Latest order details are available.<br>The view may remain same if no new order placed from last update</p>
          <p class="refresh-panel-subtext">Click refresh button below to update your view.</p>
          <button class="refresh-panel-button"
                  [disabled]="isRefreshingCache"
                  (click)="onRefreshPanelClick()">
            <mat-spinner *ngIf="isRefreshingCache" diameter="18"></mat-spinner>
            <mat-icon *ngIf="!isRefreshingCache">refresh</mat-icon>
            <span>{{ isRefreshingCache ? 'Refreshing...' : 'Refresh' }}</span>
          </button>
        </div>
      </div>
        

        <!-- Orders Section Header -->
       
<div class="orders-section">
  <!-- <div *ngIf="isBusy" class="orders-spinner-row">
  <div class="custom-spinner"></div> -->
   <app-spinner *ngIf="isBusy" [isbusy]="isBusy"></app-spinner>
  
<!-- </div> -->
  <div class="orders-inner">

    <div class="section-header">
      
      <!-- LEFT SIDE -->
      <div class="header-left">
        <span class="order-header">Orders</span>
        <div class="freshness-indicator"
                  *ngIf="cachedAtLabel"
                  [class.fresh]="cachedAtSeverity === 'fresh'"
                  [class.aged]="cachedAtSeverity === 'aged'"
                  [class.stale]="cachedAtSeverity === 'stale'">
                <mat-icon>schedule</mat-icon>
                <span>{{ cachedAtLabel }}</span>
              </div>
      </div>
      

      <!-- RIGHT SIDE -->
      <button class="filters-button"
              (click)="openFilterSidenav()"
              *ngIf="isSearchPerformed">
        <img src="assets/newimages/FiltersLarge.png" alt="" />
      </button>

    </div>
    



  </div>
</div>



        <!-- ========== ORDER CARDS ========== -->
        <!-- ✅ CENTERED LOADING SPINNER OVERLAY -->
        <div class="orders-loading-overlay" *ngIf="isFilterLoading">
          <!-- <mat-spinner 
            diameter="60"
            color="primary">
          </mat-spinner> -->
        </div>
        <div class="orders-grid-container">
          <ng-container *ngIf="orders.length > 0; else noDataTemplate">
        <div *ngFor="let orderinfo of orders">
            
            <mat-card class="order-card">
              
              <!-- Order Header -->
              <div class="order-header-section">
                <!-- Order # Row with Menu Icon (Top Row) -->
                <div class="order-header-row">
                  <div class="order-left">
                    <span class="order-label">Order # :</span>
                    <span class="order-pill">
                      {{ orderinfo.orderNumber }}
                    </span> 
                  </div>
                  <img src="/assets/newimages/threedot.png" class="menu-icon" />
                </div>
                
                <!-- Order Details Row (Below - Second Row) -->
              
<div class="order-details-row">
  <span class="ordernew-detail-item">
    <span class="detail-label">Order Created:</span>
    {{ orderinfo.orderCreationDate | date:'MM/dd/yyyy' }}
  </span>

  <span class="ordernew-detail-item">
    <span class="detail-label">Customer Requested:</span>
    {{ orderinfo.requestedDeliveryDate | date:'MM/dd/yyyy' }}
  </span>

  <span class="ordernew-detail-item">
    <span class="detail-label">Purchase Order:</span>
    {{ (orderinfo.customerPONumber) ? orderinfo.customerPONumber : 'N/A' }}
  </span>
</div>

              </div>
              
              <!-- Order Content -->
              <mat-card-content>
                
                <!-- Deliveries Header -->
                <div class="deliveries-header">
                  <span class="deliveries-title">Deliveries</span>
                  
                    <span class="deliveries-badge">
                     {{ orderinfo.deliveries.length }}
                    </span>

                </div>

                <!-- ========== DELIVERIES WRAPPER ========== -->
                <div class="deliveries-wrapper">

                    <div *ngIf="!orderinfo.deliveries || orderinfo.deliveries.length === 0">
                    <mat-card class="delivery-card status-intransit-card">
                      <mat-card-header>
                        <div class="delivery-header">
                          <div class="delivery-info">
                            <span class="delivery-header-new">
                              <b>Delivery: N/A</b>
                            </span>
                                 <span class="delivery-status">
                                  {{orderinfo.Products[0].orderLineStage | translate}}
                               </span>

                          </div>
                        </div>
                      </mat-card-header>

                      <mat-card-content>
                        <hr>
                        <!-- Use Products Template without filter -->
                        <ng-container *ngFor="let product of orderinfo.Products; let i = index">
                              <div class="products-container">
                                <div 
                                  class="product-card" 
                                  *ngIf="(i < 3 || showAllItems || orderinfo.Products.length <= 3)">
                                  
                                  <mat-card-header>
                                    <mat-card-title class="product-details">
                                      <b>{{ product.productName }}</b>
                                    </mat-card-title>
                                    
                                    <mat-card-subtitle>
                                      <div class="productnew-detail">
                                        <span class="product-detail-item">
                                          Product ID: {{ product.sKU }}
                                        </span>
                                        <span class="product-detail-item">
                                          Material Availability: {{ product.materialAvailabilityDate | date:'MM/dd/yyyy' }}
                                        </span>
                                        <span class="product-detail-item">
                                          Quantity: {{product.shippedQuantity}} of {{ product.quantityOrdered }} {{ delivery.deliveryWeightUoM }}
                                        </span>
                                      </div>
                                    </mat-card-subtitle>
                                  </mat-card-header>
                                </div>
                              </div>
                            </ng-container>
                      </mat-card-content>
                    </mat-card>
                  </div>
                  
                  <!-- Loop through deliveries -->
                  <div *ngFor="let delivery of orderinfo.deliveries; let i = index">
                    <div *ngIf="i < 5 || showMore">
                      
                      <!-- Delivery Card -->
                      <mat-card 
                        class="delivery-card" 
                        [ngClass]="{
                          'status-delivery-card': delivery.deliveryStage === 'Delivered',
                          'status-intransit-card': delivery.deliveryStage === 'In Transit' || 
                                                   delivery.deliveryStage === 'Preparing To Ship' || 
                                                   delivery.orderLineNumRef[0].orderLineStage === 'Order Management' || 
                                                   delivery.orderLineNumRef[0].orderLineStage === 'Stock Availability' || 
                                                   delivery.orderLineNumRef[0].orderLineStage === 'Credit/Pricing Issues',
                           'status-rejected-card':delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' || delivery.deliveryStage === 'Rejected/Cancelled'
                        }">

                        <!-- Delivery Header -->
                        <mat-card-header>
                          <div class="delivery-header">
                            <div class="delivery-info">
                              <span class="delivery-header-new">
                                <b>Delivery: {{ delivery.deliveryNumber ? delivery.deliveryNumber : 'N/A' }}</b>
                              </span>

                              <!-- Status Badges -->
                              <div class="delivery-badges"
                                  *ngIf="!delivery.deliveryNumber &&
                                          delivery.orderLineNumRef[0].orderLineStage != 'Rejected/Cancelled' &&
                                          delivery.deliveryStage !== 'Delivered'">
                                <span
                                  class="preparing-layout intransit-status"
                                  [ngStyle]="{'background-color': '#F0F3F5'}">
                                  {{ delivery.orderLineNumRef[0].orderLineStage | translate }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>

                              <!-- Rejected/Cancelled -->
                              <div class="delivery-badges"
                                   *ngIf="delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' &&
                                          ((delivery.deliveryStage !== null &&
                                            delivery.deliveryStage === 'Rejected/Cancelled') ||
                                           (delivery.deliveryStage !== null &&
                                            delivery.deliveryStage === '')) &&
                                          delivery.deliveryNumber">
                                <span
                                  class="rejected-layout rejected-status"
                                  [ngStyle]="{'background-color': '#facbbb'}">
                                  {{ delivery.orderLineNumRef[0].orderLineStage | translate }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>

                              <!-- Delivered -->
                              <div class="delivery-badges"
                                   *ngIf="delivery.deliveryStage === 'Delivered' &&
                                          delivery.deliveryNumber">
                                <span
                                  class="delivery-layout delivery-status"
                                  [ngStyle]="{'background-color': '#D7F7E7'}">
                                  {{ delivery.deliveryStage }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>

                              <!-- In Transit -->
                              <div class="delivery-badges"
                                    *ngIf="delivery.deliveryStage === 'In Transit' &&
                                          delivery.deliveryPlannedGIDate != null &&
                                          delivery.deliveryStage !== 'Delivered' &&
                                          delivery.deliveryNumber">
                                <span
                                  class="intransit-layout intransit-status"
                                  [ngStyle]="{'background-color': '#F0F3F5'}">
                                  {{ delivery.deliveryStage }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>

                              <!-- Preparing To Ship -->
                              <div class="delivery-badges"
                                  *ngIf="delivery.deliveryStage === 'Preparing To Ship' &&
                                          (delivery.deliveryPlannedGIDate != null ||
                                           delivery.deliveryGoodsIssueCompleted === null ||
                                           delivery.deliveryGoodsIssueCompleted === 'A' ||
                                           delivery.deliveryGoodsIssueCompleted === 'B') &&
                                          delivery.deliveryStage !== 'Delivered' &&
                                          delivery.deliveryNumber">
                                <span
                                  class="preparing-layout intransit-status"
                                  [ngStyle]="{'background-color': '#F6FAFE'}">
                                  {{ delivery.deliveryStage }}
                                </span>

                                <span
                                  class="vendor-drop-ship-badge"
                                  *ngIf="delivery.hasDropShipItems">
                                  Vendor Drop Ship
                                </span>
                              </div>
                            </div>

                            <!-- Action Buttons -->
                            <div class="button-container">
                              <!-- Download Proof Of Delivery -->
                              <button  class="download-btn-icon"
  *ngIf="delivery.deliveryStage == 'Delivered'"
  (click)="getFileNameById(delivery.deliveryNumber)"
  [disabled]="currentDownloadingId === delivery.deliveryNumber">

  <img 
    src="assets/newimages/PODDownload.png" 
    alt="Download POD"
    [style.visibility]="currentDownloadingId === delivery.deliveryNumber ? 'hidden' : 'visible'">

  <div class="spinner-overlay" *ngIf="currentDownloadingId === delivery.deliveryNumber">
    <mat-spinner diameter="20" color="accent"></mat-spinner>
  </div>

</button>
                       
                              <!-- Track Button -->
                              <button 
                               class="track-btn"
                                [disabled]="!delivery.trackUrl" 
                                (click)="showTrackingInfo(delivery.trackUrl)">
                                <img src="assets/newimages/TrackButton.png" alt="">
                              </button>
                            </div>
                          </div>
                        </mat-card-header>

                        <!-- Delivery Content -->
                        <mat-card-content>
                          
                          <!-- Delivery Details Grid -->
                          <div class="delivery-details-grid">
                            <div class="detail-item">
                              <span class="label">Carrier Name:</span>
                              <span class="value">{{ delivery.carrierName ? delivery.carrierName :'N/A' }}</span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">PRO Number:</span>
                              <span class="value">
                                {{ delivery.deliveryProNumber ? delivery.deliveryProNumber : 'N/A' }}
                              </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Origin Name:</span>
                              <span class="value">
                                {{ delivery.deliveryShippingPlant ? delivery.deliveryShippingPlant : 'N/A' }}
                              </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Actual Ship Date:</span>
                              <span class="value">
                                {{ delivery.deliveryGoodsIssueDate ? (delivery.deliveryGoodsIssueDate | date:'MM/dd/yyyy') : 'N/A' }}
                              </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Planned Ship Date:</span>
                              <span class="value">
                                {{ delivery.deliveryPlannedGIDate ? (delivery.deliveryPlannedGIDate | date:'MM/dd/yyyy') : 'N/A' }}
                              </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Estimated Delivery Date:</span>
                              <span 
                                class="value" 
                                *ngIf="delivery.deliveryStage === 'In Transit' || 
                                       delivery.deliveryStage === 'Preparing To Ship'">
                                {{ delivery.actualDeliveryDate ? (delivery.actualDeliveryDate | date:'MM/dd/yyyy'):'N/A' }}
                              </span>
                                                               <span class="value" *ngIf="delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' || 
                                                         delivery.deliveryStage === 'Rejected/Cancelled' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Stock Availability' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Order Management' ||
                                                          delivery.orderLineNumRef[0].orderLineStage === 'Credit/Pricing Issues'">
                                                          N/A
                                </span>
                            </div>
                            
                            <div class="detail-item">
                              <span class="label">Actual Delivery Date:</span>
                              <span 
                                class="value" 
                                *ngIf="delivery.deliveryStage == 'Delivered' && 
                                       (delivery.proofOfDeliveryDateTime != null || 
                                        delivery.hasDropShipItems || 
                                        delivery.actualDeliveryDate != null)">
                               {{ delivery.proofOfDeliveryDateTime ? (delivery.proofOfDeliveryDateTime | date:'MM/dd/yyyy'): (delivery.actualDeliveryDate ? (delivery.actualDeliveryDate | dateFormat): 'N/A') }}
                              </span>
                                  <span class="value" *ngIf="delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' || 
                                                         delivery.deliveryStage === 'Rejected/Cancelled' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Rejected/Cancelled' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Stock Availability' ||
                                                         delivery.orderLineNumRef[0].orderLineStage === 'Order Management' ||
                                                          delivery.orderLineNumRef[0].orderLineStage === 'Credit/Pricing Issues'">
                                                          N/A
                                </span>
                            </div>
                          </div>

                          <!-- Tracking Numbers Section -->
                          <div class="delivery-details-grid">
                            <div class="detail-item">
                              <span class="label">Delivery Tracking Numbers:</span>
                              
                              <!-- No tracking numbers -->
                              <div *ngIf="delivery.deliveryTrackingNumber?.length === 0">
                                <span>{{'N/A'}}</span>
                              </div>
                              
                              <!-- Tracking numbers list -->
                              <div class="tracking-list">
                                <span 
                                  class="value" 
                                  *ngFor="let trackingNumber of delivery.deliveryTrackingNumber; 
                                          let last = last; 
                                          let i = index">
                                  <ng-container *ngIf="i < 3 || showMoreTrackNumber">
                                    <span class="tracking-number-wrapper">
                                      <b>{{ trackingNumber.trackingNumber }}</b>
                                      <button 
                                        mat-icon-button 
                                        class="copy-btn" 
                                        (click)="copyToClipboard(trackingNumber.trackingNumber)"
                                        matTooltip="Copy tracking number"
                                        matTooltipPosition="above">
                                        <mat-icon class="copy-icon">content_copy</mat-icon>
                                      </button>
                                    </span>
                                    <span *ngIf="!last && (i < delivery.deliveryTrackingNumber.length - 1)">, </span>
                                    <br *ngIf="(i + 1) % 3 === 0 && !last && (i < 2 || showMoreTrackNumber)">
                                  </ng-container>
                                </span>

                                <!-- Show More/Less button for tracking numbers -->
                                <div 
                                  *ngIf="delivery.deliveryTrackingNumber.length > 5" 
                                  class="show-more-container">
                                  <button 
                                    mat-button 
                                    color="primary" 
                                    class="show-more-btn" 
                                    (click)="toggleShowMoreTrackNumber()">
                                    {{ showMoreTrackNumber ? 'Show Less' : 'Show More' }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <hr>

                          <!-- ========== PRODUCTS SECTION ========== -->
                       <ng-container *ngIf="{ 
                              key: orderinfo.orderNumber + '_' + delivery.deliveryNumber,
                              deliveryProducts: getProductsForDelivery(orderinfo, delivery)
                            } as ctx">
                            <div class="products-wrapper">
                              <ng-container *ngFor="let product of ctx.deliveryProducts; let i = index">
                                <div class="products-container">
                                  <div 
                                    class="product-card" 
                                    *ngIf="i < 3 || isOrderExpanded(ctx.key)">
                                    
                                    <mat-card-header>
                                      <mat-card-title class="product-details">
                                        <b>{{ product.productName }}</b>
                                        <span 
                                          *ngIf="product.orderLineStage !== delivery.deliveryStage && product.orderLineStage === 'Rejected/Cancelled'"
                                          class="product-stage-badge"
                                          [ngClass]="{
                                            'badge-rejected': product.orderLineStage === 'Rejected/Cancelled'
                                            }">
                                            {{ product.orderLineStage | translate }}
                                        </span>
                                      </mat-card-title>
                                      
                                      <div class="productnew-detail-wrapper">
                                        <div class="productnew-detail">
                                          <span class="product-detail-item">
                                            Product ID: {{ product.sKU }}
                                          </span>
                                          <span class="product-detail-item">
                                            Material Availability: {{ product.materialAvailabilityDate | date:'MM/dd/yyyy' }}
                                          </span>
                                          <span class="product-detail-item">
                                            Quantity: {{product.shippedQuantity}} of {{ product.quantityOrdered }} {{ delivery.deliveryWeightUoM }}
                                          </span>
                                        </div>
                                      </div>
                                    </mat-card-header>
                                  </div>
                                </div>
                              </ng-container>

                              <!-- View All Items Button -->
                              <div 
                                class="view-all-items" 
                                *ngIf="ctx.deliveryProducts.length > 3">
                                <button 
                                  mat-button 
                                  color="primary" 
                                  (click)="toggleViewAllItems(ctx.key)">
                                  <span>{{ isOrderExpanded(ctx.key) ? 'Show Less' : 'View All' }}</span>
                                  <mat-icon>{{ isOrderExpanded(ctx.key) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                                </button>
                              </div>
                            </div>
                          </ng-container>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </div>

                  <!-- Show More/Less Button for Deliveries -->
                  <div class="show-more-container" *ngIf="orderinfo.deliveries.length > 5">
                    <button 
                      mat-button 
                      color="primary" 
                      class="show-more-btn" 
                      (click)="toggleShowMore()">
                      {{ showMore ? 'Show less' : 'Show more' }}
                      <mat-icon>{{ showMore ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
           </ng-container>
           
        </div>

    


  <ng-template #noDataTemplate>
    <div *ngIf="filterForm.get('searchTerm')?.value" class="no-results-container">
      <div>
        <div class="no-results-text">No matching records found</div>
      </div>
    </div>
  </ng-template>

      </div>
    </div>

<!-- Chatbot Component -->
  <app-filter-side-nav (filtersApplied)="onFiltersApplied($event)"></app-filter-side-nav>
</app-layout>